<template>
  <div class="home">
    <b-col cols="12" class="mb-2">
      PAGINA PRINCIPAL
      <b-col class="p-3">
        Texto para los proveedores indicando que si quiere registrarse debe hacer click en el boton de abajo, y si ya tiene cuenta que presione en Ingresar.
      </b-col>
    </b-col>
    <b-button @click="goToForm()" size="sm" variant="primary">REGISTRARME</b-button>
  </div>
</template>

<script>
export default {
  methods:{
    goToForm(){
      this.$router.push('/providers/form');
    }
  }
}
</script>
